import React, { useState, useRef, useEffect, useMemo } from "react";
import { HiMenu } from "react-icons/hi";
import { HiOutlineLogout, HiUserCircle, HiChevronDown } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

function Head({ onToggleSidebar, sidebarOpen }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Parse stored admin info
  const adminInfo = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("adminInfo") || "{}");
    } catch {
      return {};
    }
  }, []);

  const handleLogout = () => {
    // Delete auth cookie
    document.cookie = "token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT;";
    // Clear stored admin data
    localStorage.removeItem("userRole");
    localStorage.removeItem("adminInfo");
    // Redirect
    navigate("/login", { replace: true });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const userName = adminInfo.name || adminInfo.username || adminInfo.email || "User";
  const userRole = adminInfo.role || "N/A";

  return (
    <div className="bg-white text-green-500 h-16 px-4 flex items-center justify-between font-bold text-2xl border-b border-neutral-200 relative">
      {/* Menu Button - only show when sidebar is closed */}
      {!sidebarOpen && (
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-md hover:bg-neutral-100 transition-colors"
          aria-label="Toggle sidebar"
        >
          <HiMenu className="text-2xl text-neutral-700" />
        </button>
      )}
      
      {/* Title */}
      <span className={`flex-1 ${!sidebarOpen ? 'text-center lg:text-left lg:pl-4' : 'text-center lg:text-left'}`}>
        Welcome to Ankuaru
      </span>

      {/* User Dropdown - always visible */}
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex items-center gap-2 px-3 py-2 rounded-md hover:bg-neutral-100 transition-colors"
          aria-label="User menu"
        >
          <HiUserCircle className="text-2xl text-neutral-700" />
          <span className="text-sm font-normal text-neutral-700 hidden sm:block">
            {userName}
          </span>
          <HiChevronDown
            className={`text-lg text-neutral-700 transition-transform ${
              dropdownOpen ? "rotate-180" : ""
            }`}
          />
        </button>

        {/* Dropdown Menu */}
        {dropdownOpen && (
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg border border-neutral-200 py-2 z-50">
            {/* User Info */}
            <div className="px-4 py-3 border-b border-neutral-200">
              <div className="text-sm text-neutral-700">
                <div className="font-semibold text-neutral-900">{userName}</div>
                <div className="text-xs text-neutral-500 mt-1 capitalize">
                  Role: {userRole}
                </div>
              </div>
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
            >
              <HiOutlineLogout className="text-lg" />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Head;
